import React from 'react';
import _ from 'underscore';
import {
  Alert,
  FormGroup,
  ControlLabel,
  Row,
  Col,
  FormControl,
  Button,
} from 'react-bootstrap';

import LocationStore from 'stores/LocationStore';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import GeofenceMap from './GeofenceMap';

class CreateAddressForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      location: props.location,
    };
  }

  handleLocationDrag(lat, lng) {
    this.setState((prevState) => {
      const location = prevState.location;
      location.lat = lat;
      location.lng = lng;

      return { location };
    });
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    this.setState((prevState) => {
      if (prevState.location.street !== newProps.location.street) {
        const location = _.extend({}, prevState.location, newProps.location);
        return { location };
      }
      return {};
    });
  }

  handleFieldChange(field, value) {
    this.setState(
      (prevState) => {
        let location = prevState.location;
        location[field] = value;

        const suite_or_apt = location.suite_or_apt
          ? `${location.suite_or_apt}, `
          : '';
        location.address = `${location.street}, ${suite_or_apt}${location.city}, ${location.state}, ${location.zipcode}`;

        return { location };
      },
      () => {
        LocationStore.clearCreateLocationError();
      },
    );
  }

  componentWillUnmount() {
    this.setState({ location: {} });
  }

  handleSave() {
    const location = this.state.location;
    location._type = 'point';
    location._sub_type = 'Address';
    this.props.onCreateLocation(location);
  }

  render() {
    const { t } = this.props;
    if (!this.state.location) return null;
    const location = this.state.location;

    return (
      <div>
        <Row>
          <Col xs={12}>
            <h4>{t('GEOFENCE')}</h4>
            <GeofenceMap
              location={location}
              height={250}
              onLocationDrag={this.handleLocationDrag.bind(this)}
            />
          </Col>
        </Row>
        <Row className="mt-1">
          <Col xs={6}>
            <ControlLabel>{t('LONGITUDE')}</ControlLabel>
            <FormControl disabled value={location.lng} />
          </Col>
          <Col xs={6}>
            <ControlLabel>{t('LATITUDE')}</ControlLabel>
            <FormControl disabled value={location.lat} />
          </Col>
        </Row>
        <Row style={{ marginTop: 10 }}>
          <Col xs={12}>
            <FormGroup>
              <ControlLabel>{titleize(t('NAME'))}</ControlLabel>
              <FormControl
                value={location.name || ''}
                onChange={(e) => this.handleFieldChange('name', e.target.value)}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <FormGroup>
              <ControlLabel>{titleize(t('ADDRESS'))}</ControlLabel>
              <FormControl
                onChange={(e) =>
                  this.handleFieldChange('street', e.target.value)
                }
                value={location.street || ''}
              />
            </FormGroup>
          </Col>
          <Col xs={12}>
            <FormGroup>
              <ControlLabel>{t('ADDRESS_2')}</ControlLabel>
              <FormControl
                onChange={(e) =>
                  this.handleFieldChange('suite_or_apt', e.target.value)
                }
                value={location.suite_or_apt || ''}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col xs={6}>
            <FormGroup>
              <ControlLabel>{titleize(t('CITY'))}</ControlLabel>
              <FormControl
                onChange={(e) => this.handleFieldChange('city', e.target.value)}
                value={location.city || ''}
              />
            </FormGroup>
          </Col>
          <Col xs={3}>
            <FormGroup>
              <ControlLabel>{titleize(t('STATE'))}</ControlLabel>
              <FormControl
                maxLength={2}
                onChange={(e) =>
                  this.handleFieldChange('state', e.target.value)
                }
                value={location.state || ''}
              />
            </FormGroup>
          </Col>
          <Col xs={3}>
            <FormGroup>
              <ControlLabel>{titleize(t('POSTAL_CODE'))}</ControlLabel>
              <FormControl
                maxLength={5}
                onChange={(e) =>
                  this.handleFieldChange('zipcode', e.target.value)
                }
                value={location.zipcode || ''}
              />
            </FormGroup>
          </Col>
        </Row>
        {this.props.error && (
          <Row>
            <Col xs={12}>
              <Alert bsStyle="danger">{this.props.error}</Alert>
            </Col>
          </Row>
        )}
        <Row style={{ marginTop: 10 }}>
          <Col xs={8} />
          <Col xs={4}>
            <div className="float-right">
              <Button onClick={() => this.handleSave()} bsStyle="primary">
                {this.state.locationPending && (
                  <i className="fa fa-circle-o-notch fa-spin mr-2" />
                )}
                {titleize(t('SAVE'))}
              </Button>
              <Button
                onClick={() => this.props.onCreateLocationCancel()}
                bsStyle="link"
              >
                {titleize(t('CANCEL'))}
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default withTranslation()(CreateAddressForm);
